module.exports = __webpack_public_path__ + "static/media/rightArrow.845b31d4.svg";